export class Router extends EventTarget {
  constructor(routes) {
    super();
    this.routes = routes;
    this.onPopState = () => this.resolve();
    window.addEventListener('popstate', this.onPopState);
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[data-link]');
      if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || anchor.target) return;
      const url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin) return;
      event.preventDefault();
      this.navigate(`${url.pathname}${url.search}${url.hash}`);
    });
  }

  navigate(path, { replace = false } = {}) {
    if (replace) history.replaceState({}, '', path);
    else history.pushState({}, '', path);
    this.resolve();
  }

  match(pathname = location.pathname) {
    for (const route of this.routes) {
      const match = pathname.match(route.pattern);
      if (match) {
        const params = Object.fromEntries(route.keys.map((key, index) => [key, decodeURIComponent(match[index + 1] ?? '')]));
        return { ...route, params };
      }
    }
    return this.routes.find((route) => route.notFound) ?? null;
  }

  resolve() {
    const route = this.match();
    const event = new CustomEvent('route', { detail: route });
    this.dispatchEvent(event);
  }

  dispose() {
    window.removeEventListener('popstate', this.onPopState);
  }
}
